import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HelperUtils, LoggingService } from "@merri/common";
import { Observable } from "rxjs";
import { AppConfigService, AuthService } from "../services";

@Injectable({
  providedIn: "root",
})
export class ShadowInterceptor implements HttpInterceptor {
  constructor(private _authService: AuthService, private _appConfigService: AppConfigService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shadowBlock(req.url, req.method)) {
      LoggingService.log("shadowBlock", req.url, req.method);
      throw new Error("This action is not available during a shadow session");
    }

    return next.handle(req);
  }

  private shadowBlock(url: string, method: string): boolean {
    if (!this._authService.shadowMode) {
      return false;
    }

    if (!url.startsWith(this._appConfigService.getConfig().baseApiUrl)) {
      return false;
    }

    const blocked = this._appConfigService.getProtectedConfig()?.shadowBlockRegexdUrls();

    if (!blocked) {
      return false;
    }

    const extracted = HelperUtils.extractPathFromUrl(url);

    return blocked.some(i => extracted.match(i[0]) && i[1] === method);
  }
}
